export default __webpack_public_path__ + "static/media/resume.a0f1a022.pdf";